import { Component, OnDestroy, OnInit, } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TagItem } from 'app/components/common/tag/tag.component';
import { AuthService } from 'app/services/auth.service';
import { UserRepository } from 'app/services/database/user.repository';
import { DeviceService } from 'app/services/device.service';
import { PresentationService } from 'app/services/presentation/presentation.service';
import { Logger } from 'app/shared/logger';
import { LoggerFactory } from 'app/shared/loggerFactory';
import { DevicesModule } from 'app/views/devices/devices.module';
import { DeviceModel } from 'app/views/devices/models/device.model';
import { UserModel } from 'app/views/user/models/user.model';
import * as moment from 'moment';

@Component({
    selector: 'psm-dashboard',
    templateUrl: 'dashboard.component.html',
    styleUrls: ['dashboard.component.scss']
})
export class DashboardComponent implements OnDestroy, OnInit {

    // Prevents flickers
    public userHasPresentations: boolean = true;
    public userHasDevices: boolean = true;

    public nav: any;
    private logger: Logger;

    public constructor(
        private authService: AuthService,
        private deviceService: DeviceService,
        private presentationService: PresentationService,
        private userRepository: UserRepository,
        private loggerFactory: LoggerFactory,
        private translate: TranslateService
    ) {
        this.nav = document.querySelector('nav.navbar');
        this.logger = loggerFactory.create('DashboardComponent');
    }

    public async ngOnInit() {
        this.nav.className += ' white-bg';

        let user = await this.authService.getCurrentUser();
        let userModel = await this.userRepository.get(user.uid);

        this.userHasPresentations = userModel.presentations && userModel.presentations.length > 0;
        this.userHasDevices = userModel.devices && userModel.devices.length > 0;
    }

    public ngOnDestroy(): any {
        this.nav.classList.remove('white-bg');
    }
}



// WEBPACK FOOTER //
// ./src/app/views/appviews/dashboard.component.ts